import { Navigate, Routes, Route } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';
import NotificationSidebar from './components/NotificationSidebar';
import PreviewSidebar from './components/PreviewSidebar';
import useRoutes from '../../hooks/useRoutes';
import CreateCompanyModal from '../../views/admin/companies/components/CreateCompanyModal';
import useAuth from '../../hooks/useAuth';

export default function AdminLayout() {
  const { getRoutes } = useRoutes('/admin');
  const { user } = useAuth();

  if (!user) return <Navigate to="/auth" replace />;

  return (
    <div className="flex w-full h-screen overflow-hidden">
      <Sidebar />

      <div className="flex w-full h-full transition-all duration-300 ease-in-out overflow-hidden">

        <div className="flex-1 flex flex-col h-full overflow-hidden">
          <Topbar />

          <div className="flex-1 2xl:px-6 2xl:py-4 px-4 py-3 overflow-y-auto">
            <Routes>
              {getRoutes()}
              <Route path="*" element={<Navigate to="/admin/home" replace />} />
            </Routes>
          </div>
        </div>

        <NotificationSidebar />
        <PreviewSidebar />
        <CreateCompanyModal />
      </div>
    </div>
  );
}
